import { cn } from '@/lib/utils'

// Wraps the whole experience in a device frame on desktop (reads like an app-store shot) and
// goes full-bleed on real phones. Dark theme is applied here so it covers every screen.
export function PhoneFrame({ dark, children }: { dark: boolean; children: React.ReactNode }) {
  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-gradient-to-b from-[#2f2925] to-[#161310] sm:p-6">
      <div
        className={cn(
          'relative flex h-[100dvh] w-full flex-col overflow-hidden bg-background sm:h-[860px] sm:max-h-[94vh] sm:w-[402px] sm:rounded-[2.75rem] sm:border sm:border-black/10 sm:shadow-2xl',
          dark && 'dark',
        )}
      >
        {children}
      </div>
    </div>
  )
}
